import React from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./components/SomaStandard/AuthComponents/PrivateRoute";
import Logoff from "./routes/Logoff";
import Home from "./routes/Home/HomeNovo";
import Login from "./routes/Login";
import SomaPlace from "./routes/SomaPlace";

const Routes = () => (
  
    <Switch>
      <Route exact path="/Login" component={Login} />
      <PrivateRoute exact path="/Logoff" component={Logoff} />
      <PrivateRoute exact path="/" component={Home} />
      <PrivateRoute path="/SomaPlace" component={SomaPlace} />
    </Switch>
);

export default Routes;
